import React from 'react'
import ReactDOM from 'react-dom'
import ReactDOMClient from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { PublicClientApplication } from "@azure/msal-browser"
import { MsalProvider } from "@azure/msal-react"
import { msalConfig } from "./authConfig"
import store from './store'
import { Provider } from 'react-redux'
import App from './App'
import * as serviceWorker from './registerServiceWorker'

import CssBaseline from '@mui/material/CssBaseline'
import { FcThemeProvider } from './theme/FcThemeProvider'
import { HelmetProvider, Helmet } from 'react-helmet-async'

import { CookiesProvider } from 'react-cookie'

import config from 'devextreme/core/config'

export const msalInstance = new PublicClientApplication(msalConfig)
await msalInstance.initialize()
const rootElement = document.getElementById('root')
const root = ReactDOMClient.createRoot(rootElement)

//config({ licenseKey: 'ewogICJmb3JtYXQiOiAxLAogICJjdXN0b21lcklkIjogImFiYmZmZTJkLTBlMjktNDRjMS04ZjViLTAyMTcxMjMyNDUyNyIsCiAgIm1heFZlcnNpb25BbGxvd2VkIjogMjUxCn0=.DJpngcZOrOfz9O2A1lgU2cu7o0E7o7SGsI+2BLFymS1YuAad/F5J76/jC/Knv51T7r8lmbtgE49/n7lHccmpsXZZkrRSmAQRBnVu/E4+rMBAPX1wxXAvbn/SmnSbBeJ7HZBa8g==' })
// config({ licenseKey: 'ewogICJmb3JtYXQiOiAxLAogICJjdXN0b21lcklkIjogImFiYmZmZTJkLTBlMjktNDRjMS04ZjViLTAyMTcxMjMyNDUyNyIsCiAgIm1heFZlcnNpb25BbGxvd2VkIjogMjUyCn0=.KJ2kRDYiclgj8aX1wrjVVca9bG6g0HsJklB4ZjZpmSXzNX6JiIwtrDgpX+P1iWgI8Uau8jNzkC4EMQ+ff1RxtHtJN0NILnA0UPBA0k49lVx0PDUAy9DQZtAKzk9pfMlbNwOACA==' })
// config({ licenseKey: 'LCXv1RGVGOUFHdVFzNEpwdldFL2NyZHd6YTZEYmJNc1REZkxkY2x6NE8vNEUvNDdVTzNPOGN6ekNuZ2ttZFVzaU5nSjFKeTRybzZmUllQWG1OcFM5NUwrTHUyd2RzUlhZZkxrNmZBem1hcW1NeUd5TGthaDhkZVlEWnpjRXhhc3JiT1NXdGw1NUE9PUJIKkRZZSUqMUQxZExAZi1KYmsxLVgyTjFuSitqbT5MY3Q2TiMoQz4+OUMhSWFpQEQkREBbeVJ5aSxfSUZCZXJ6LDtMSylqUnJKQjgtSmJiODdlWilCbT56TkVTcCw8aUNmUVNyOVZqPHAsRkxZSTNKa19aYmE3KDRbelJvbmN0TEc7Pms4bGwkKgpgYTFUXUdfYk8uSjVKIWl3SmQ+QncjclpjaVBadVtPRWFhYi5iR1Q4XV9hRzhvSDFdOF9fLkU4VUVjdUdKVTBKb2NFeXlKCl9VYF9fOT9fP1Q5XyxvR0c/XWI2VCxONlQ5YFVhVSxiOmFdMU9UX29UR1RUb11HYVVfX2FHX0dPMUhHMW9iX0hUR19dMWJHVF1PXWJfYWFhXW8xb11IVVVHR0dHT2IxVFRiVUhfVVRfX19fX19fX18=' })
config({ licenseKey: 'LCPv1c<9nZj-7e>,@ZNRK:HeocHav%NR8IJeE2>:1!<c@eHdY(QFES_Q[e+!!GyagpRryZH3zVi34IH+3Sjyg,Na7So!<c>dH9%,fSoa1,n)1I_@neySk9iE@eH!Epe->SjF3GnV+7_,!><,B%J!L:j-g7>a9I%mvpR,t2N3LINXo3Jr8>N+%%Ncmk7L;67yF%pFF6Ld!I7!$>Q8Baj@G9j!EpLd!6p-66_!v>%X<2p@)Ii-)>Qd)2g!:pg-FI%-:I%8v2%!:2i-vI%!)>jL<27@:9K9vaj@Fp<-6aN-@2g!Q6g-:>Q4:G_@@9Qdv6<!F6<dFI7yFI7yFI7Ll' })

root.render(
    <MsalProvider instance={msalInstance}>
        <Provider store={store}>
            <CookiesProvider>
                <FcThemeProvider>
                    <CssBaseline />
                    <HelmetProvider>
                        <Helmet
                            titleTemplate="%s - Powered by GPS Innovations"
                            defaultTitle="FleetConnect - Powered by GPS Innovations"
                        />
                        <BrowserRouter>
                            <App />
                        </BrowserRouter>
                    </HelmetProvider>
                </FcThemeProvider>
            </CookiesProvider>
        </Provider>
    </MsalProvider>
)

serviceWorker.unregister()

